import AppToolbar from '@/app-theme/components/app/AppToolbar.vue'
import AppFooter from '@/app-theme/components/app/AppFooter.vue'

export default {
  name      : 'SimpleLayout',
  components: {
    AppToolbar,
    AppFooter
  },
  mixins   : [],
  dataStore: {},
  data     : function () {
    return {}
  },
  computed: {},
  watch   : {},
  created() {
  },
  mounted() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  methods: {}
}
